/* eslint-disable */

/**
 * Blocker used to present the Paper Cash Deposit experience.
 *
 * Note that this blocker is designed to be used as the terminating blocker for
 * the Paper Cash Deposit flow, so it is never expected to be resolved.
 */
export interface PaperCashDepositBlocker {
  turorial_carousel?: PaperCashDepositBlockerTutorialCarousel;
  map_screen?: PaperCashDepositBlockerMapScreen;
  search_screen?: PaperCashDepositBlockerSearchScreen;
  merchant_options?: PaperCashDepositBlockerMerchantOptions;
  barcode_expired_screen?: PaperCashDepositBlockerBarcodeExpiredScreen;
  /**
   * If non-null, a dialog to display when the experience is first presented
   * informing the customer that they have reached their deposit limits.
   */
  limits_reached_dialog?: PaperCashDepositBlockerLimitsReachedDialog;
}

export interface PaperCashDepositBlockerTutorialCarousel {
  pages?: PaperCashDepositBlockerTutorialCarouselPage[];
  next_page_button_text?: string;
  submit_button_text?: string;
}

export interface PaperCashDepositBlockerTutorialCarouselPage {
  illustration?: PaperCashDepositBlockerTutorialCarouselPageIllustration;
  title?: string;
  description?: string;
}

export enum PaperCashDepositBlockerTutorialCarouselPageIllustration {
  FIND_A_LOCATION = "FIND_A_LOCATION",
  SHOW_THE_BARCODE = "SHOW_THE_BARCODE",
  GIVE_CASH_TO_CASHIER = "GIVE_CASH_TO_CASHIER",
}

export interface PaperCashDepositBlockerMapScreen {
  header_title?: string;
  show_barcode_button_text?: string;
  search_button_accessibility_label?: string;
  tutorial_button_accessibility_label?: string;
  search_header_title_prefix?: string;
  no_nearby_locations_title_text?: string;
  no_nearby_locations_detail_text?: string;
  no_nearby_locations_button_text?: string;
  location_disabled_title_text?: string;
  location_disabled_detail_text?: string;
  location_disabled_settings_text?: string;
  location_disabled_ignore_text?: string;
}

export interface PaperCashDepositBlockerSearchScreen {
  search_bar_placeholder?: string;
  explanation_title_text?: string;
  explanation_detail_text?: string;
  recent_section_header_text?: string;
  results_section_header_text?: string;
}

export interface PaperCashDepositBlockerMerchantOptions {
  directions_button_text?: string;
  show_barcode_button_text?: string;
  copy_address_button_text?: string;
}

export interface PaperCashDepositBlockerBarcodeExpiredScreen {
  title_text?: string;
  detail_text?: string;
  reload_barcode_button_text?: string;
}

export interface PaperCashDepositBlockerLimitsReachedDialog {
  title_text?: string;
  detail_text?: string;
  dismiss_button_text?: string;
}
